import { createStyles } from '@lsy-netline-ui/netline-ui';

export default () => createStyles({
  containerAnchorOriginTopCenter: {
    '& > *': {
      marginTop: -2,
    },
  },
});
